export { BlockDetails } from './BlockDetails';
export type { DetailsValidation } from './BlockDetails';
